import React from 'react';
import './features.css';
import { Feature } from '../../components';

const featuresData = [
  {
    title: 'Hidroizolacije',
    text: 'Naša firma pruža vrhunsku hidroizolaciju kao ključni korak ka zaštiti vaših objekata od nepoželjne vode i vlage koristeći najsavremenije materijale i tehnike kako bismo osigurali dugotrajnu zaštitu!',
  },
  {
    title: 'Termoizolacije',
    text: 'Naša firma stručno projektuje i pruža inovativna rešenja koja obezbeđuju optimalnu energetsku efikasnost i udobnost vaših prostora.',
  },
  {
    title: 'Sanacije',
    text: 'Transformišemo vaše objekte kroz visokokvalitetne sanacije koje obuhvataju sve - od restauracije do modernizacije. Naša firma donosi novi život vašim prostorima kroz stručno vođene procese i pažljivo izabrane materijale.',
  },
  {
    title: 'Specijalni Radovi',
    text: 'Nullam sodales vel elit ut laoreet. Duis finibus nisl sed elit pretium fermentum.',
  }
];

// nase usluge

const Features = () => {
  return (
    <div className='bersia__features section__padding' id='usluge'>
      <div className='bersia__features-heading'>
        <h1 className='gradient__text-header'>Osnovne djelatnosti firme BERSIA d.o.o.</h1>
        <p className='gradient__text-header'></p>
      </div>
      <div className='bersia__features-container'>
        {featuresData.map((item, index) =>(
          <Feature title = {item.title} text = {item.text} key={item.title + index}/>
        ))}
      </div>
    </div>
  )
}

export default Features
